import { Close } from "../../../assets/icons/Close";
import { InfoCircle } from "../../../assets/icons/InfoCircle";
import { Copy } from "../../../assets/icons/Copy";
import { useState } from "react";
import { ModalNotDuplicableCalculs } from "./modals/ModalNotDuplicableCalculs";
import { Archive } from "../../../assets/icons/Archive";
import { Trash } from "../../../assets/icons/Trash";
import { AddFolder } from "../../../assets/icons/AddFolder";
import ModalAssignCalculToFolders from "../../folders/containers/ModalAssignCalculToFolders";
import { FileCheck } from "../../../assets/icons/FileCheck";
import { ModalDownloadFiles } from "./modals/ModalDownloadFiles";
import { ModalDelArchCalculs } from "./modals/ModalDelArchCalculs";
import { Download } from "../../../assets/icons/Download";
import CustomTooltip from "../../../common/components/CustomTooltip";
import DeleteModal from "../../../common/components/DeleteModal";
import { ModalGenerateBulkFiles } from "./modals/ModalGenerateBulkFiles";

// type SelectedCalculs: {
//  id: string,
//  name: string,
//  isDuplicable: boolean,
//  isFinished: boolean,
//  isRestorable?: boolean,
//  simulationMode?: boolean,
//  folderIds: string[],
//  outputs: string[]
//}[]

const CalculsFooterActions = ({
  selectedCalculs,
  setSelectedCalculs,
  manageCalculsBulk,
  folderId,
  bulkGenerateReports,
  bulkDownloadReports,
}) => {
  const [isModalNotDuplicableOpen, setIsModalNotDuplicableOpen] =
    useState(false);
  const [isModalAddToFolderOpen, setIsModalAddToFolderOpen] = useState(false);
  const [isModalDownloadFilesOpen, setIsModalDownloadFilesOpen] =
    useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isModalDelArchOpen, setIsModalDelArchOpen] = useState(false);
  const [dontShowDelArchCalculsModal, setDontShowDelArchCalculsModal] =
    useState(false);
  const [isModalGenerateOpen, setIsModalGenerateOpen] = useState(false);
  const [dontShowGenerateCalculsModal, setDontShowGenerateCalculsModal] =
    useState(false);
  const isDelArchCalculsClosed = localStorage.getItem("isDelArchCalculsClosed");
  const isGenerateCalculsClosed = localStorage.getItem(
    "isGenerateCalculsClosed",
  );

  const duplicateCalculs = () => {
    manageCalculsBulk(
      "duplicate",
      selectedCalculs
        .filter((calcul) => calcul.isDuplicable)
        .map((calcul) => calcul.id),
      folderId,
    );
    setSelectedCalculs(
      selectedCalculs.filter((calcul) => !calcul.isDuplicable),
    );
  };

  const handleDuplicateClick = () => {
    if (selectedCalculs.some((calcul) => !calcul.isDuplicable)) {
      //if some calculs are not duplicable, open the modal to confirm duplication of only the duplicable calculs
      setIsModalNotDuplicableOpen(true);
    } else {
      duplicateCalculs();
    }
  };

  const archiveCalculs = (filterCalculs) => {
    manageCalculsBulk(
      "archive",
      selectedCalculs
        .filter((calcul) => calcul.isFinished)
        .map((calcul) => calcul.id),
      folderId,
    );
    if (filterCalculs) {
      setSelectedCalculs(
        selectedCalculs.filter((calcul) => !calcul.isFinished),
      );
    }
  };

  const deleteCalculs = (filterCalculs) => {
    manageCalculsBulk(
      "delete",
      selectedCalculs
        .filter((calcul) => !calcul.isFinished)
        .map((calcul) => calcul.id),
      folderId,
    );
    if (filterCalculs) {
      setSelectedCalculs(selectedCalculs.filter((calcul) => calcul.isFinished));
    }
  };

  const handleDeleteAndArchiveClick = () => {
    if (!isDelArchCalculsClosed) {
      setIsModalDelArchOpen(true);
    } else {
      deleteAndArchiveCalculs();
    }
  };

  const deleteAndArchiveCalculs = () => {
    archiveCalculs(false);
    deleteCalculs(false);
    setSelectedCalculs([]);
    if (!isDelArchCalculsClosed && dontShowDelArchCalculsModal) {
      localStorage.setItem("isDelArchCalculsClosed", true);
    }
    setIsModalDelArchOpen(false);
  };

  const handleGeneratelick = () => {
    if (!isGenerateCalculsClosed) {
      setIsModalGenerateOpen(true);
    } else {
      generateBulkReports();
    }
  };

  const generateBulkReports = () => {
    bulkGenerateReports(
      selectedCalculs
        .filter((calcul) => !calcul.isFinished)
        .map((calcul) => ({
          id: calcul.id,
          outputs: calcul.outputs,
        })),
      folderId,
    );
    setSelectedCalculs(
      selectedCalculs.map((calcul) => ({ ...calcul, isFinished: true })),
    );
    if (!isGenerateCalculsClosed && dontShowGenerateCalculsModal) {
      localStorage.setItem("isGenerateCalculsClosed", true);
    }
    setIsModalGenerateOpen(false);
  };

  const downloadReports = (types) => {
    bulkDownloadReports(
      selectedCalculs
        .filter((calcul) => calcul.isFinished)
        .map((calcul) => calcul.id),
      types,
      folderId,
    );
  };

  return (
    <>
      <div className="footer-container bg-interaction d-flex align-items-center justify-content-between text-white">
        <div className="d-flex align-items-center">
          <button className="no-style" onClick={() => setSelectedCalculs([])}>
            <Close className="cursor-pointer text-white" size={22} bold />
          </button>
          <div className="ml-2 d-flex align-items-center fw-500">
            <span style={{ display: "block", paddingTop: 3 }}>
              {selectedCalculs.length}
              {selectedCalculs.length > 1 ? " Sélectionnés" : " Sélectionné"}
            </span>
            <span
              style={{ marginLeft: 6 }}
              data-toggle="dropdown"
              data-tooltip-id="calculs-footer-infos"
              onClick={(e) => e.stopPropagation()}
              onMouseEnter={(e) => e.stopPropagation()}
            >
              <InfoCircle size={16} />
            </span>
            <CustomTooltip id="calculs-footer-infos" place="top" dark>
              <div className="text">
                Selon le statut des calculs sélectionnés les options disponibles
                dans dans le bandeau d’action varient.
              </div>
            </CustomTooltip>
          </div>
        </div>
        <div className="d-flex align-items-center calculs-footer-actions">
          {/* Duplicate */}
          {selectedCalculs.some((calcul) => calcul.isDuplicable) && (
            <button
              className="no-style text-white d-flex align-items-center fw-500"
              onClick={handleDuplicateClick}
            >
              <Copy size={16} bold />
              <span style={{ marginLeft: 6 }}>Dupliquer</span>
            </button>
          )}
          {/* Generate */}
          {selectedCalculs.some((calcul) => !calcul.isFinished) && (
            <button
              className="no-style text-white d-flex align-items-center fw-500"
              onClick={handleGeneratelick}
            >
              <FileCheck size={16} bold />
              <span style={{ marginLeft: 6 }}>Générer</span>
            </button>
          )}
          {/* Download */}
          {selectedCalculs.some((calcul) => calcul.isFinished) && (
            <button
              className="no-style text-white d-flex align-items-center fw-500"
              onClick={() => setIsModalDownloadFilesOpen(true)}
            >
              <Download size={16} bold />
              <span style={{ marginLeft: 6 }}>Télécharger</span>
            </button>
          )}
          {/* Add to folder */}
          {folderId !== "archives" && (
            <button
              className="no-style text-white d-flex align-items-center fw-500"
              onClick={() => setIsModalAddToFolderOpen(true)}
            >
              <AddFolder size={16} bold />
              <span style={{ marginLeft: 6 }}>Ajouter à un dossier</span>
            </button>
          )}
          {/* Archive */}
          {folderId !== "archives" &&
            selectedCalculs.every((calcul) => calcul.isFinished) && (
              <button
                className="no-style text-white d-flex align-items-center fw-500"
                onClick={() => archiveCalculs(true)}
              >
                <Archive size={16} bold />
                <span style={{ marginLeft: 6 }}>Archiver</span>
              </button>
            )}
          {/* Delete */}
          {selectedCalculs.every((calcul) => !calcul.isFinished) && (
            <button
              className="no-style text-white d-flex align-items-center fw-500"
              onClick={() => setIsDeleteModalOpen(true)}
            >
              <Trash size={16} bold />
              <span style={{ marginLeft: 6 }}>Supprimer</span>
            </button>
          )}
          {/* Delete/Archive */}
          {folderId !== "archives" &&
            selectedCalculs.some((calcul) => !calcul.isFinished) &&
            selectedCalculs.some((calcul) => calcul.isFinished) && (
              <button
                className="no-style text-white d-flex align-items-center fw-500"
                onClick={handleDeleteAndArchiveClick}
              >
                <Trash size={16} bold />
                <span style={{ marginLeft: 6 }}>Supprimer / Archiver</span>
              </button>
            )}
        </div>
      </div>
      <ModalNotDuplicableCalculs
        isOpen={isModalNotDuplicableOpen}
        onClose={() => setIsModalNotDuplicableOpen(false)}
        calculs={selectedCalculs}
        duplicateCalculs={duplicateCalculs}
      />
      <ModalAssignCalculToFolders
        isOpen={isModalAddToFolderOpen}
        onClose={() => setIsModalAddToFolderOpen(false)}
        folderId={folderId}
        calculIds={selectedCalculs.map((calcul) => calcul.id)}
        calculFolders={selectedCalculs.map((calcul) => calcul.folderIds).flat()}
      />
      <ModalDownloadFiles
        isOpen={isModalDownloadFilesOpen}
        onClose={() => setIsModalDownloadFilesOpen(false)}
        calculs={selectedCalculs}
        downloadReports={downloadReports}
        displayXmlInies={selectedCalculs.some((calcul) =>
          calcul.outputs.some((output) => output.includes("inies")),
        )}
        displayXml={selectedCalculs.some((calcul) =>
          calcul.outputs.some((output) => output.includes("xml")),
        )}
        displayXls={selectedCalculs.some((calcul) =>
          calcul.outputs.some((output) => output.includes("xls")),
        )}
      />
      <ModalDelArchCalculs
        isOpen={isModalDelArchOpen}
        onClose={() => setIsModalDelArchOpen(false)}
        onValidate={deleteAndArchiveCalculs}
        dontShowDelArchCalculsModal={dontShowDelArchCalculsModal}
        setDontShowDelArchCalculsModal={setDontShowDelArchCalculsModal}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onSubmit={() => deleteCalculs(true)}
      />
      <ModalGenerateBulkFiles
        isOpen={isModalGenerateOpen}
        onClose={() => setIsModalGenerateOpen(false)}
        onValidate={generateBulkReports}
        dontShowGenerateCalculsModal={dontShowGenerateCalculsModal}
        setDontShowGenerateCalculsModal={setDontShowGenerateCalculsModal}
        selectedCalculs={selectedCalculs}
      />
    </>
  );
};

export default CalculsFooterActions;
